// 20 art-grade drawing palette swatches
export const PALETTE = [
  { name: 'Charcoal', hex: '#2D2A32' },
  { name: 'Off-White', hex: '#FAF8F5' },
  { name: 'Warm Red', hex: '#E03E36' },
  { name: 'Coral', hex: '#FF6B6B' },
  { name: 'Amber', hex: '#F59E0B' },
  { name: 'Gold', hex: '#EAB308' },
  { name: 'Sage', hex: '#84A98C' },
  { name: 'Forest', hex: '#2D6A4F' },
  { name: 'Teal', hex: '#2EC4B6' },
  { name: 'Sky', hex: '#4DA8DA' },
  { name: 'Indigo', hex: '#4338CA' },
  { name: 'Violet', hex: '#7C3AED' },
  { name: 'Rose', hex: '#E11D48' },
  { name: 'Blush', hex: '#FDA4AF' },
  { name: 'Sand', hex: '#D4A574' },
  { name: 'Slate', hex: '#64748B' },
  { name: 'Burnt Sienna', hex: '#A0522D' },
  { name: 'Ochre', hex: '#CC7722' },
  { name: 'Lavender', hex: '#A78BFA' },
  { name: 'Midnight', hex: '#1E1B4B' },
];

// 10 distinct member avatar colours
export const MEMBER_COLOURS = [
  '#E03E36', '#F59E0B', '#2D6A4F', '#4DA8DA', '#7C3AED',
  '#E11D48', '#2EC4B6', '#CC7722', '#4338CA', '#FDA4AF',
];

export const DEFAULT_DRAW_COLOUR = '#2D2A32';

export function assignMemberColour(existingColours = []) {
  const used = new Set(existingColours);
  return MEMBER_COLOURS.find(c => !used.has(c)) || MEMBER_COLOURS[0];
}
